import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M23.5,0h-3a.47.47,0,0,0-.35.15L10.62,9.68a7.5,7.5,0,1,0,3.7,3.7l2.32-2.31,1.93.65a1,1,0,0,0,1-.19,1,1,0,0,0,.34-.91L19.51,8.2l.72-.73,1.46.67A1,1,0,0,0,23.07,7l-.51-1.81,1.29-1.3A.47.47,0,0,0,24,3.5V.5A.5.5,0,0,0,23.5,0ZM7,18.5A1.5,1.5,0,1,1,5.5,17,1.5,1.5,0,0,1,7,18.5Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }